
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resellers",
      function () {
        return require("private-next-pages/resellers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resellers"])
      });
    }
  